

































































































































































































import {
  defineComponent,
  useRoute,
  computed,
  ref,
  watch,
  useFetch,
  onBeforeUnmount,
  useContext,
  onMounted,
  onUpdated,
  onUnmounted,
  useMeta,
} from '@nuxtjs/composition-api';
import dayjs from 'dayjs';
import { debounce } from 'lodash-es';
import urlJoin from 'url-join';
import ProductDetailAboutCellarTransport from '~/components/pages/Product/Detail/ProductDetailAboutCellarTransport.vue';
import ProductDetailArchiveBanner from '~/components/pages/Product/Detail/ProductDetailArchiveBanner.vue';
import ProductDetailCommentSection from '~/components/pages/Product/Detail/ProductDetailCommentSection.vue';
import ProductDetailFlexibleItemFooter from '~/components/pages/Product/Detail/ProductDetailFlexibleItemFooter.vue';
import ProductDetailFooter from '~/components/pages/Product/Detail/ProductDetailFooter.vue';
import ProductDetailGiftOptionSection from '~/components/pages/Product/Detail/ProductDetailGiftOptionSection.vue';
import ProductDetailImageSection from '~/components/pages/Product/Detail/ProductDetailImageSection.vue';
import ProductDetailInfoSection from '~/components/pages/Product/Detail/ProductDetailInfoSection.vue';
import ProductDetailIntroSection from '~/components/pages/Product/Detail/ProductDetailIntroSection.vue';
import ProductDetailMainSection from '~/components/pages/Product/Detail/ProductDetailMainSection.vue';
import ProductDetailOldVintageAnnotation from '~/components/pages/Product/Detail/ProductDetailOldVintageAnnotation.vue';
import ProductDetailPickupReviewCard from '~/components/pages/Product/Detail/ProductDetailPickupReviewCard.vue';
import ProductDetailProducerIntroSection from '~/components/pages/Product/Detail/ProductDetailProducerIntroSection.vue';
import ProductDetailProducingAreaIntroSection from '~/components/pages/Product/Detail/ProductDetailProducingAreaIntroSection.vue';
import ProductDetailSetItemSection from '~/components/pages/Product/Detail/ProductDetailSetItemSection.vue';
import ProductDetailSpecificationSection from '~/components/pages/Product/Detail/ProductDetailSpecificationSection.vue';
import ProductDetailStaffReviewLink from '~/components/pages/Product/Detail/ProductDetailStaffReviewLink.vue';
import ProductDetailStaffReviewSection from '~/components/pages/Product/Detail/ProductDetailStaffReviewSection.vue';
import ProductDetailStockSection from '~/components/pages/Product/Detail/ProductDetailStockSection.vue';
import ProductDetailTasteSection from '~/components/pages/Product/Detail/ProductDetailTasteSection.vue';
import TopSection from '~/components/pages/Top/TopSection.vue';
import AppLoader from '~/components/partials/App/AppLoader.vue';
import ContentRelatedArticles from '~/components/partials/Content/ContentRelatedArticles.vue';
import GlobalHeaderMenu from '~/components/partials/Global/GlobalHeaderMenu.vue';
import LayoutDefault from '~/components/partials/Layout/LayoutDefault.vue';
import RecommendItemsHorizontal from '~/components/partials/SilverEgg/RecommendItemsHorizontal.vue';
import { useListFavorite } from '~/composables/contents/useListFavorite';
import { LayoutProps } from '~/composables/internals/useLayoutPropsProvider';
import { useKarteItemDetailTag } from '~/composables/karte/useKarteItemDetailTag';
import { useSilverEggApi } from '~/composables/silverEgg/useSilverEggApi';
import { useUuidEncryption } from '~/composables/silverEgg/useUuidEncryption';
import { useCriteoTag } from '~/composables/tag/useCriteoTag';
import { useGoogleTag } from '~/composables/tag/useGoogleTag';
import { useLineTag } from '~/composables/tag/useLineTag';
import { useKeepScroll } from '~/composables/useKeepScroll';
import { useLayoutProps } from '~/composables/useLayoutProps';
import { useRuntimeConfig } from '~/composables/useRuntimeConfig';
import { useStore } from '~/composables/useStore';
import {
  PRODUCT_DETAIL_REVIEW_LIST_LIMIT,
  STAFF_REVIEW_ANCHOR_POINT,
  PRODUCT_COLOR_ID,
  PRODUCT_PARAM_QUERIES,
  SORT_PARAMETERS,
  SPEC,
  SMARTPHONE,
  CATEGORY_ID,
  REQUEST_NUM_LARGE,
} from '~/constants';
import { url, nonNullable, filterSplitEmptyItem } from '~/utils';
import { getArchiveAreaCategoryCode, getArchiveColorCategoryCode } from '~/utils/archive';
import { PageError } from '~/utils/error';
import { getSpecialPricePromotion } from '~/utils/modules/products';
import { RecommendItem } from '~/types/common/silverEgg';
import { CommentData } from '~/types/modules/comment';
import { ArticleCard } from '~/types/modules/contents';
import {
  ProductShowECResponseSchema,
  ProductShowCMSResponseSchema,
  ProductDetailGiftOption,
  ProductDetailPickupReview,
  ProductVariantShow,
} from '~/types/modules/product';
import { StaffReview } from '~/types/modules/staff';
import { TopItemDetail } from '~/types/modules/top';
import type { BreadcrumbsItem } from '~/types/ui';
import {
  BooleanLike,
  FavoriteTypes,
  ProductCategoryId,
  ProductCategoryText,
  ProductSetType,
  ProductTypeId,
} from '~/enums';

export default defineComponent({
  components: {
    AppLoader,
    GlobalHeaderMenu,
    LayoutDefault,
    ProductDetailImageSection,
    ProductDetailTasteSection,
    ProductDetailMainSection,
    ProductDetailPickupReviewCard,
    ProductDetailStaffReviewLink,
    ProductDetailInfoSection,
    ProductDetailSpecificationSection,
    ProductDetailStockSection,
    ProductDetailIntroSection,
    ProductDetailSetItemSection,
    ProductDetailOldVintageAnnotation,
    ProductDetailProducerIntroSection,
    ProductDetailProducingAreaIntroSection,
    ProductDetailCommentSection,
    ProductDetailStaffReviewSection,
    ProductDetailGiftOptionSection,
    ProductDetailAboutCellarTransport,
    ProductDetailFooter,
    ProductDetailFlexibleItemFooter,
    ContentRelatedArticles,
    ProductDetailArchiveBanner,
    TopSection,
    RecommendItemsHorizontal,
  },
  setup() {
    const { redirect, i18n, app } = useContext();
    const store = useStore();
    const route = useRoute();
    const { setKarteItemDetailTag } = useKarteItemDetailTag();
    const { FRONTEND_ORIGIN } = useRuntimeConfig();
    const criteoTag = useCriteoTag();
    const { fetchAllFavorites } = useListFavorite();
    const { checkIsFavorite } = useListFavorite();
    const { fetchRecommendItems, fetchHistoryItems } = useSilverEggApi();
    const { encryptUuid } = useUuidEncryption();
    const { sendLineViewEvent } = useLineTag();
    const { setGoogleViewTag } = useGoogleTag();
    const { scrollToHash, scrollToPreviousPosition, setPageData } = useKeepScroll();
    const isFavorite = computed(() => checkIsFavorite(productCode.value, FavoriteTypes.ITEM));
    const productCode = computed(() => route.value.params.code);
    const isMobile = computed(() => app.$ua.deviceType() === SMARTPHONE);
    const dynamicSectionsRef = ref<HTMLDivElement | null>(null);
    const ecDetailResponse = ref<ProductShowECResponseSchema | null>(null);
    const cmsDetailResponse = ref<ProductShowCMSResponseSchema | null>(null);
    const staffReviewResponse = ref<StaffReview[]>([]);
    const staffReviewTotal = ref(0);
    const relatedArchives = ref<ArticleCard[]>([]);
    const relatedMagazines = ref<ArticleCard[]>([]);
    const giftOptions = ref<ProductDetailGiftOption>();
    const comments = ref<CommentData[]>([]);
    const isLoading = ref(true);
    const relatedSetItems = ref<TopItemDetail[]>([]);
    /** もっと詳細を見るを開いているかどうか */
    const isOpenMoreDetail = ref<boolean>(
      store.getters['internals/keepScroll/detailsElements'](route.value.path, route.value.fullPath)?.[2]?.isOpen ??
        false
    );
    // ↓シルバーエッグ用↓
    const uuidHash = ref<string | undefined>('');
    const silverEggRecommendItems = ref<RecommendItem[]>();
    const recommendRqid = ref('');
    const recommendSpec = computed(() => (isMobile.value ? SPEC.PROD_DETAIL_SP : SPEC.PROD_DETAIL_PC));
    const silverEggHistoryItems = ref<RecommendItem[]>();
    const historyRqid = ref('');
    const historySpec = ref('');
    // ↑シルバーエッグ用↑
    // ↓同じ生産者の別アイテム用↓
    const sameProducerItems = ref<TopItemDetail[]>([]);
    const sameProducerItemsTitle = computed(() => {
      if (uniqueCategories.includes(productCategory.value.toString())) {
        return i18n.t('Item-14.sameProducerItems.title').toString();
      }
      return i18n.t('Item-03.sameProducerItems.title').toString();
    });
    // ↑同じ生産者の別アイテム用↑

    const uniqueCategories = [
      ProductCategoryId.FOOD.toString(),
      ProductCategoryId.WINE_GOODS.toString(),
      ProductCategoryId.WINE_CELLAR.toString(),
    ];

    const { fetchState } = useFetch(async () => {
      await Promise.all(
        [
          async () => {
            try {
              ecDetailResponse.value = await store.dispatch('product/detail/fetchECProductDetail', {
                path: { code: productCode.value },
              });
              // カテゴリがワイン以外の場合、詳細アコーディオンを常に開いておく
              // TODO: 後ほど管理画面制御になるので削除する
              if (ecDetailResponse.value.categories[0]?.id !== ProductCategoryId.WINE) {
                isOpenMoreDetail.value = true;
              }
              // 商品種別がプリムールだったらプリムール詳細にリダイレクト
              if (ecDetailResponse.value?.type_id === ProductTypeId.PRIMEUR) {
                return redirect(301, url('PRIMEUR_DETAIL', { code: productCode.value }));
              }
            } catch {
              // データサイズが大きいので、フロントでは処理を走らせない
              if (process.server) {
                // 現行の親なし子商品リダイレクトを行う
                const { default: parentlessItems } = await import('~/assets/data/item/parentless-items.json');
                const matchedItemCode = parentlessItems.find((code) => code === productCode.value);

                if (matchedItemCode) {
                  return redirect(301, url('ITEM_DETAIL', { code: `${matchedItemCode}P` }));
                }
              }

              throw new PageError(404, {});
            }
          },
          async () => {
            try {
              const { items, total } = await store.dispatch('modules/staff/fetchStaffReviewList', {
                productCode: productCode.value,
                count: PRODUCT_DETAIL_REVIEW_LIST_LIMIT,
              });
              staffReviewResponse.value = items;
              staffReviewTotal.value = total;
            } catch {
              // 何もしない
            }
          },
        ].map((fn) => fn())
      );

      if (!ecDetailResponse.value || !ecDetailResponse.value.product_variants.length) {
        throw new PageError(404, {});
      }

      try {
        const { id, review_settings } = ecDetailResponse.value;

        cmsDetailResponse.value = await store.dispatch('product/detail/fetchCMSProductDetail', {
          productId: id,
        });

        if (review_settings?.review_group_id) {
          const { data = [] } = await store.dispatch('modules/reviews/fetchCommentsByReviewGroupId', {
            path: {
              review_group_id: review_settings.review_group_id,
            },
            query: {
              limit: PRODUCT_DETAIL_REVIEW_LIST_LIMIT,
              page: 1,
              sort: SORT_PARAMETERS.CREATED_AT,
              status: 'approved',
            },
          });

          comments.value = data;
        }

        giftOptions.value = await store.dispatch('product/detail/fetchGiftOptions', {
          path: { code: ecDetailResponse.value.code },
        });

        if (ecDetailResponse.value.master_settings.producer) {
          // 同生産者の商品を取得
          sameProducerItems.value = await store.dispatch('product/detail/fetchProductsForItemDetail', {
            producerId: ecDetailResponse.value.master_settings.producer.id,
            currentProductCode: ecDetailResponse.value.code,
          });
        }

        // この商品が含まれるセット商品を取得
        const { related_set_product_codes } = ecDetailResponse.value;
        if (related_set_product_codes?.length) {
          relatedSetItems.value = await store.dispatch('product/detail/fetchProductsForItemDetail', {
            relatedSetCodes: related_set_product_codes,
          });
        }
      } catch {
        // 何もしない
      }
      isLoading.value = false;
    });

    onMounted(async () => {
      // NOTE: htmlタグに直接class名追加する方法以外は何故か効かない
      document.documentElement.classList.add('scroll-smooth');

      // karteの送信処理には全件取得する必要があります
      fetchAllFavorites(FavoriteTypes.ITEM);

      // シルバーエッグからレコメンド取得
      if (app.$ua.isFromCrawler()) return;
      uuidHash.value = await encryptUuid();
      const [recommendResult, historyResult] = await Promise.all([
        await fetchRecommendItems({
          prod: [productCode.value], // トラッキング用
          spec: recommendSpec.value,
          num: REQUEST_NUM_LARGE,
          cat: CATEGORY_ID.PRODUCT,
          cust: uuidHash.value,
        }),
        await fetchHistoryItems(REQUEST_NUM_LARGE, productCode.value),
      ]);
      silverEggRecommendItems.value = recommendResult.items;
      recommendRqid.value = recommendResult.rqid;
      silverEggHistoryItems.value = historyResult.items;
      historyRqid.value = historyResult.rqid;
      historySpec.value = historyResult.spec;
    });

    onUpdated(() => {
      if (dynamicSectionsRef.value) {
        const scrollPosition: number = store.getters['internals/keepScroll/scrollY'](
          route.value.path,
          route.value.fullPath
        );
        const scrollObserver = new MutationObserver(
          debounce((mutationsList, observer) => {
            // 前回のスクロール位置が保持されていれば、ハッシュより復元を優先する
            if (scrollPosition > 0) {
              scrollToPreviousPosition(500);
            } else {
              scrollToHash(500);
            }
            observer.disconnect();
          }, 500)
        );
        scrollObserver.observe(dynamicSectionsRef.value, { attributes: true, childList: true, subtree: true });
        dynamicSectionsRef.value.id = 'dynamic-sections-wrapper'; // HACK: 変更を検知させるために属性を付与
      }
    });

    onUnmounted(() => {
      setPageData({
        // 0:ギフトサービスについて, 1:注文・配送・納品・引き取りについて（セラー）, 2:もっと詳細を見る
        detailsElements: [
          { elementId: 'about-gift-service' },
          { elementId: 'about-cellar-transport' },
          { isOpen: isOpenMoreDetail.value },
        ],
      });

      document.documentElement.classList.remove('scroll-smooth');
    });

    useLayoutProps(() => {
      const name = ecDetailResponse.value?.langs?.find(({ id }) => id === 'ja')?.name || '不明な商品名';
      const producer = ecDetailResponse.value?.master_settings?.producer?.name_kana || '';
      const description =
        ecDetailResponse.value?.lead_message || i18n.t('Common.item.description', { name }).toString();
      const breadcrumbs: BreadcrumbsItem[] = [];
      const canonical = ecDetailResponse.value?.code && urlJoin(FRONTEND_ORIGIN, route.value.path);

      const layoutProps: LayoutProps = {
        layout: {
          header: 'always',
          footer: 'always',
          headerMenu: 'never',
          topBanner: 'needed',
        },
        head: {
          title: `${name}${producer ? ` / ${producer}` : ''}`,
          description,
          canonical,
          noindex: ecDetailResponse.value?.is_no_index,
        },
        og: {
          image: ecDetailResponse.value?.product_image_1,
        },
        breadcrumbs,
        jsonld: [
          {
            type: 'Product',
            data: {
              ecDetail: ecDetailResponse.value,
              comments: comments.value,
            },
          },
        ],
        fetchState,
      };

      if (!ecDetailResponse.value) {
        return layoutProps;
      }

      const { categories, master_settings } = ecDetailResponse.value;
      const path = url('ITEM_LIST');
      // ワインカテゴリのクエリはパンくずではつけない
      const categoryIds = categories
        .map(({ id }) => id.toString())
        .filter((id) => id !== ProductCategoryId.WINE.toString());
      // ワインセットの場合、他のカテゴリをパンくずにつけない
      if (categoryIds.includes(ProductCategoryId.WINE_SET.toString())) {
        breadcrumbs.push({
          title: ProductCategoryText.WINE_SET,
          to: { path, query: { _ctg: ProductCategoryId.WINE_SET.toString(), _qty: BooleanLike.TRUE } },
        });
        breadcrumbs.push({ title: name, to: null });
        return layoutProps;
      }
      categories.forEach((category, index) => {
        breadcrumbs.push({
          title: category.name,
          to: { path, query: { _ctg: categoryIds.slice(0, index + 1), _qty: BooleanLike.TRUE } },
        });
      });
      // 特定のカテゴリに属する商品詳細でカテゴリ以外の項目をパンくずに含めたくない場合
      if (
        [...categoryIds, ...uniqueCategories].filter((id) => categoryIds.includes(id) && uniqueCategories.includes(id))
          .length > 0
      ) {
        breadcrumbs.push({ title: name, to: null });
        return layoutProps;
      }
      if (master_settings?.color && master_settings.color.name && master_settings.color.id) {
        /** スパークリングワインの色：色のパンくずを`_color=5&_color=6&_color=7`にする */
        const SPARKLING_WINE_COLOR_IDS = [
          PRODUCT_COLOR_ID.SPARKLING_WHITE,
          PRODUCT_COLOR_ID.SPARKLING_ROSE,
          PRODUCT_COLOR_ID.SPARKLING_RED,
        ];
        if (SPARKLING_WINE_COLOR_IDS.includes(master_settings?.color.id.toString())) {
          breadcrumbs.push({
            title: 'スパークリングワイン',
            to: { path, query: { _color: SPARKLING_WINE_COLOR_IDS, _qty: BooleanLike.TRUE } },
          });
        } else {
          breadcrumbs.push({
            title: master_settings.color.name,
            to: { path, query: { _color: master_settings.color.id.toString(), _qty: BooleanLike.TRUE } },
          });
        }
      }
      if (master_settings?.producing_areas) {
        master_settings.producing_areas.forEach((area) => {
          if (area.id && area.name) {
            breadcrumbs.push({
              title: area.name,
              to: { path, query: { _area: area.id.toString(), _qty: BooleanLike.TRUE } },
            });
          }
        });
      }
      if (master_settings?.producer && master_settings?.producer?.name_kana && master_settings?.producer?.id) {
        breadcrumbs.push({
          title: master_settings.producer.name_kana,
          to: { path, query: { _producers: master_settings.producer.id.toString(), _qty: BooleanLike.TRUE } },
        });
      }
      breadcrumbs.push({ title: name, to: null });
      return layoutProps;
    });

    const productCategory = computed(() => ecDetailResponse.value?.categories[0]?.id || ProductCategoryId.WINE);
    const pickupReview = computed((): ProductDetailPickupReview | null => {
      if (!ecDetailResponse.value || !ecDetailResponse.value.pickup_review) {
        return null;
      }
      const { code, review_settings, pickup_review } = ecDetailResponse.value;
      return {
        rating: pickup_review.rating,
        link: {
          name: i18n.t('Item-03.pickupReview.link', { count: review_settings?.review_total || 0 }).toString(),
          to: url('ITEM_DETAIL', { code }) + '#detail_Rtoaster',
        },
        title: pickup_review.title,
        body: pickup_review.body,
      };
    });
    const staffIcons = computed((): string[] => {
      if (staffReviewResponse.value.length === 0) {
        return [];
      }
      const icons = [];

      if (staffReviewResponse.value.length >= 1) {
        icons.push(staffReviewResponse.value[0].user.image_url);
      }
      if (staffReviewResponse.value.length >= 2) {
        icons.push(staffReviewResponse.value[1].user.image_url);
      }
      if (staffReviewResponse.value.length >= 3) {
        icons.push(staffReviewResponse.value[2].user.image_url);
      }

      return icons;
    });
    /** 現在の年から15年以上前のヴィンテージを持つか */
    const hasOldVintage = computed(() =>
      ecDetailResponse.value?.product_variants?.some((variant) => {
        const vintageDate = dayjs(variant.vintage_code);
        return vintageDate.isValid() && dayjs().diff(vintageDate, 'year') >= 15;
      })
    );
    const isShownTasteSection = computed(() => {
      return (
        [
          ProductCategoryId.WINE,
          ProductCategoryId.OTHER_ALCOHOL,
          ProductCategoryId.OTHER_DRINK,
          ProductCategoryId.NON_ALCOHOL,
          ProductCategoryId.GIFT_SET,
        ].includes(productCategory.value) && ecDetailResponse.value?.master_settings.color
      );
    });
    const isShownStockSection = computed(() => {
      return [ProductCategoryId.WINE, ProductCategoryId.OTHER_ALCOHOL, ProductCategoryId.GIFT_SET].includes(
        productCategory.value
      );
    });
    const isShownProducerAreaIntroSection = computed(() => productCategory.value !== ProductCategoryId.OTHER);
    const isShownProducingAreaIntroSection = computed(() =>
      [
        ProductCategoryId.WINE,
        ProductCategoryId.OTHER_ALCOHOL,
        ProductCategoryId.OTHER_DRINK,
        ProductCategoryId.GIFT_SET,
      ].includes(productCategory.value)
    );
    const isWineCategory = computed(() =>
      [ProductCategoryId.WINE, ProductCategoryId.GIFT_SET].includes(productCategory.value)
    );
    const isShownComment = computed(() => !!ecDetailResponse.value?.review_settings?.review_group_id);
    const isShownStaffReview = computed(() => staffReviewResponse.value.length > 0);
    const isShownSetItemSection = computed(() => {
      return (
        (productCategory.value === ProductCategoryId.WINE_SET || productCategory.value === ProductCategoryId.WINE) &&
        (ecDetailResponse.value?.set_type as ProductSetType) === ProductSetType.FLEXIBLE_SET
      );
    });
    const isShownAboutCellarTransport = computed(() => productCategory.value === ProductCategoryId.WINE_CELLAR);

    watch(ecDetailResponse, async () => {
      if (!ecDetailResponse.value || process.server) {
        return;
      }
      const { id, code, master_settings, categories, label, related_article_tags, langs } = ecDetailResponse.value;
      // レコメ用PV数計測
      const idList = [
        id,
        master_settings?.producer?.id,
        ...(master_settings?.producing_areas?.map((area) => area.id) || []),
        ...(master_settings?.brands?.map((brand) => brand.id) || []),
        master_settings?.color?.id,
        ...categories.map((category) => category.id),
      ].filter(nonNullable);
      if (window.TLAB) {
        window.TLAB.push(['Beacon::PutAccessLog', idList.map((id) => `product_${id}`)]);
      }

      // 関連する特集を取得
      try {
        // ラベル、色、生産地が未設定のときは関連特集不要
        if (!label && !master_settings?.color?.name && master_settings?.producing_areas.length === 0) {
          relatedArchives.value = [];
        } else {
          const labels = filterSplitEmptyItem('_', label);
          const cmsWineType = getArchiveColorCategoryCode(categories[0]?.id, master_settings?.color?.name);
          const cmsAreaCategory = getArchiveAreaCategoryCode(
            master_settings?.producing_areas?.map((area) => area.name_en).filter(nonNullable)
          );
          relatedArchives.value = await store.dispatch('product/detail/fetchRelatedArchives', {
            permalinks: labels,
            cmsWineType,
            cmsAreaCategory,
          });
        }
      } catch {
        // 何もしない
      }

      // 関連する読み物を取得
      if (!related_article_tags) {
        relatedMagazines.value = [];
      } else {
        const tagIds = filterSplitEmptyItem('_', related_article_tags);
        try {
          relatedMagazines.value = await store.dispatch('product/detail/fetchRelatedArticles', {
            tagIds,
          });
        } catch {
          // 何にもしない
        }
      }

      // ↓ここから外部連携タグ
      // KARTE
      setKarteItemDetailTag(ecDetailResponse.value);
      // criteo計測用タグ
      criteoTag.setItemDetailTag(ecDetailResponse.value.code);
      // LINE
      sendLineViewEvent(productCode.value);
      // GTM（GA4）のeコマースの商品詳細閲覧タグ
      const minPrice = ecDetailResponse.value.product_variants.reduce(
        (variant1: ProductVariantShow, variant2: ProductVariantShow) => {
          const price1 = variant1.price_settings.price_excluding_tax;
          const price2 = variant2.price_settings.price_excluding_tax;
          return Math.min(price1, price2) === price1 ? variant1 : variant2;
        }
      );
      const { price_excluding_tax, price_including_tax } = minPrice.price_settings;
      const specialPrice = getSpecialPricePromotion(minPrice.price_settings);
      setGoogleViewTag(specialPrice ? specialPrice.price_excluding_tax : price_excluding_tax, {
        item_name: langs?.find(({ id }) => id === 'ja')?.name,
        item_id: code,
        price: specialPrice ? specialPrice.price_including_tax : price_including_tax,
        item_category: categories[0].name,
      });
    });

    onBeforeUnmount(() => {
      store.commit('product/detail/clearSelectedFlexibleSetItems');
    });

    useMeta(() => {
      const productId = ecDetailResponse.value?.id;
      return {
        script: [
          {
            type: 'text/javascript',
            innerHTML: productId
              ? `loopassDmpTrack({ pv_event: '商品詳細', item_id: '${productId}' });`
              : `loopassDmpTrack({ pv_event: '商品詳細' });`,
          },
        ],
      };
    });

    return {
      url,
      PRODUCT_PARAM_QUERIES,
      BooleanLike,
      productCode,
      ecDetailResponse,
      cmsDetailResponse,
      comments,
      staffReviewResponse,
      staffReviewTotal,
      relatedArchives,
      relatedMagazines,
      isLoading,
      productCategory,
      pickupReview,
      staffIcons,
      hasOldVintage,
      isShownTasteSection,
      isShownStockSection,
      isShownProducerAreaIntroSection,
      isShownProducingAreaIntroSection,
      isShownComment,
      isShownStaffReview,
      isShownSetItemSection,
      isShownAboutCellarTransport,
      isWineCategory,
      STAFF_REVIEW_ANCHOR_POINT,
      isFavorite,
      silverEggRecommendItems,
      recommendRqid,
      recommendSpec,
      silverEggHistoryItems,
      historyRqid,
      historySpec,
      giftOptions,
      dynamicSectionsRef,
      sameProducerItems,
      sameProducerItemsTitle,
      uniqueCategories,
      relatedSetItems,
      isOpenMoreDetail,
    };
  },
  head: {},
});
